


















import { Component, Mixins } from 'vue-property-decorator';
import TableComponent from '@/components/Table/TableComponent.vue';
import TableMixin from '@/mixins/tableMixins';
import { fetchPSpice } from '@/api/drilldown';
import { View } from '@/interfaces';

@Component({
  components: {
    TableComponent,
  },
})
export default class PSpiceModel extends Mixins(TableMixin) {
  public defaultView: View = {
    name: 'Default',
    fields: ['File_Name', 'Folder_Type'],
    default: false,
    selected: true,
  };

  async mounted(): Promise<void> {
    this.getURLParams();
    await this.fetchData();
    this.isLoadingNewRecords = false;
    this.emitListener();
  }

  public async fetchData(): Promise<void> {
    this.isExportDisabled = true;
    this.data = await fetchPSpice({
      id: this.id,
      filters: this.query,
      lowerThreshold: this.itemsRange[0],
      upperThreshold: this.itemsRange[1],
      sortingName: this.sorting.name,
      sortingOrder: this.sorting.order,
    });
    this.isExportDisabled = false;
  }
}
